/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-min-bar-length',
  templateUrl: './theme-option-axes-min-bar-length.component.html',
  styleUrls: ['./theme-option-axes-min-bar-length.component.css']
})
export class ThemeOptionAxesMinBarLengthComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'axes_minBarLength';

  constructor() {
    this.showDetails = false;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setAxes(this.optionType, value, this.axesXY, this.axesIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

}
